import Objective_v2_S1_Clearer from './objectives/season_one/Objective_v2_S1_Clearer.png';
import Objective_v2_S1_Cruncher from './objectives/season_one/Objective_v2_S1_Cruncher.png';
import Objective_v2_S1_Edges from './objectives/season_one/Objective_v2_S1_Edges.png';
import Objective_v2_S1_LeftSampler from './objectives/season_one/Objective_v2_S1_LeftSampler.png';
import Objective_v2_S1_Loner from './objectives/season_one/Objective_v2_S1_Loner.png';
import Objective_v2_S1_MetalBonus from './objectives/season_one/Objective_v2_S1_MetalBonus.png';
import Objective_v2_S1_Socialite from './objectives/season_one/Objective_v2_S1_Socialite.png';
import Objective_v2_S1_Spacer from './objectives/season_one/Objective_v2_S1_Spacer.png';
import Objective_v2_S1_WideSpacer from './objectives/season_one/Objective_v2_S1_WideSpacer.png';

export const objectivesS1Images = [
    Objective_v2_S1_Clearer,
    Objective_v2_S1_Cruncher,
    Objective_v2_S1_Edges,
    Objective_v2_S1_LeftSampler,
    Objective_v2_S1_Loner,
    Objective_v2_S1_MetalBonus,
    Objective_v2_S1_Socialite,
    Objective_v2_S1_Spacer,
    Objective_v2_S1_WideSpacer
];

import Objective_v2_S2_AnimalHandler from './objectives/season_two/Objective_v2_S2_AnimalHandler.png';
import Objective_v2_S2_Borders from './objectives/season_two/Objective_v2_S2_Borders.png';
import Objective_v2_S2_CenterSampler from './objectives/season_two/Objective_v2_S2_CenterSampler.png';
import Objective_v2_S2_CrossOver from './objectives/season_two/Objective_v2_S2_CrossOver.png';
import Objective_v2_S2_MeritEarner from './objectives/season_two/Objective_v2_S2_MeritEarner.png';
import Objective_v2_S2_Minimalist from './objectives/season_two/Objective_v2_S2_Minimalist.png';
import Objective_v2_S2_Moderate from './objectives/season_two/Objective_v2_S2_Moderate.png';
import Objective_v2_S2_Organizer from './objectives/season_two/Objective_v2_S2_Organizer.png';
import Objective_v2_S2_Shrimp from './objectives/season_two/Objective_v2_S2_Shrimp.png';

export const objectivesS2Images = [
    Objective_v2_S2_AnimalHandler,
    Objective_v2_S2_Borders,
    Objective_v2_S2_CenterSampler,
    Objective_v2_S2_CrossOver,
    Objective_v2_S2_MeritEarner,
    Objective_v2_S2_Minimalist,
    Objective_v2_S2_Moderate,
    Objective_v2_S2_Organizer,
    Objective_v2_S2_Shrimp
];

import Objective_v2_S3_Biggen from './objectives/season_three/Objective_v2_S3_Biggen.png';
import Objective_v2_S3_CargoMaster from './objectives/season_three/Objective_v2_S3_CargoMaster.png';
import Objective_v2_S3_Centrist from './objectives/season_three/Objective_v2_S3_Centrist.png';
import Objective_v2_S3_Lefty from './objectives/season_three/Objective_v2_S3_Lefty.png';
import Objective_v2_S3_Packed from './objectives/season_three/Objective_v2_S3_Packed.png';
import Objective_v2_S3_Righty from './objectives/season_three/Objective_v2_S3_Righty.png';
import Objective_v2_S3_SeasonedWorker from './objectives/season_three/Objective_v2_S3_SeasonedWorker.png';
import Objective_v2_S3_TrueFriend from './objectives/season_three/Objective_v2_S3_TrueFriend.png';
import Objective_v2_S3_VarietyPack from './objectives/season_three/Objective_v2_S3_VarietyPack.png';

export const objectiveS3Images = [
    Objective_v2_S3_Biggen,
    Objective_v2_S3_CargoMaster,
    Objective_v2_S3_Centrist,
    Objective_v2_S3_Lefty,
    Objective_v2_S3_Packed,
    Objective_v2_S3_Righty,
    Objective_v2_S3_SeasonedWorker,
    Objective_v2_S3_TrueFriend,
    Objective_v2_S3_VarietyPack
];

import Starter_Chopping from './action_cards/starter_cards/Starter_Chopping.png';
import Starter_Chopping_2 from './action_cards/starter_cards/Starter_Chopping_2.png';
import Starter_Fishing from './action_cards/starter_cards/Starter_Fishing.png';
import Starter_Fishing_2 from './action_cards/starter_cards/Starter_Fishing_2.png';
import Starter_Mining from './action_cards/starter_cards/Starter_Mining.png';
import Starter_Mining_2 from './action_cards/starter_cards/Starter_Mining_2.png';
import Starter_Tending from './action_cards/starter_cards/Starter_Tending.png';
import Starter_Tending_2 from './action_cards/starter_cards/Starter_Tending_2.png';
import Starter_ZenithOrders from './action_cards/starter_cards/Starter_ZenithOrders.png';

export const actionStarterImages = [
    Starter_Chopping,
    Starter_Chopping_2,
    Starter_Fishing,
    Starter_Fishing_2,
    Starter_Mining,
    Starter_Mining_2,
    Starter_Tending,
    Starter_Tending_2,
    Starter_ZenithOrders
];

import Task_v2_S1_CaveFisher from './action_cards/season_one/base/Task_v2_S1_CaveFisher.png';
import Task_v2_S1_FarmClearer from './action_cards/season_one/base/Task_v2_S1_FarmClearer.png';
import Task_v2_S1_FarmMiner from './action_cards/season_one/base/Task_v2_S1_FarmMiner.png';
import Task_v2_S1_NoviceFisher from './action_cards/season_one/base/Task_v2_S1_NoviceFisher.png';
import Task_v2_S1_NoviceForager from './action_cards/season_one/base/Task_v2_S1_NoviceForager.png';
import Task_v2_S1_NoviceMiner from './action_cards/season_one/base/Task_v2_S1_NoviceMiner.png';
import Task_v2_S1_RiverDredger from './action_cards/season_one/base/Task_v2_S1_RiverDredger.png';
import Task_v2_S1_RiverFisher from './action_cards/season_one/base/Task_v2_S1_RiverFisher.png';

export const actionS1BaseImages = [
    Task_v2_S1_CaveFisher,
    Task_v2_S1_FarmClearer,
    Task_v2_S1_FarmMiner,
    Task_v2_S1_NoviceFisher,
    Task_v2_S1_NoviceForager,
    Task_v2_S1_NoviceMiner,
    Task_v2_S1_RiverDredger,
    Task_v2_S1_RiverFisher
];

import Hive_SeasonCards_2026_07_23_S1_CaveFisher from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_CaveFisher.png';
import Hive_SeasonCards_2026_07_23_S1_FarmClearer from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_FarmClearer.png';
import Hive_SeasonCards_2026_07_23_S1_FarmMiner from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_FarmMiner.png';
import Hive_SeasonCards_2026_07_23_S1_NoviceFisher from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_NoviceFisher.png';
import Hive_SeasonCards_2026_07_23_S1_NoviceForager from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_NoviceForager.png';
import Hive_SeasonCards_2026_07_23_S1_NoviceMiner from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_NoviceMiner.png';
import Hive_SeasonCards_2026_07_23_S1_RiverDredger from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_RiverDredger.png';
import Hive_SeasonCards_2026_07_23_S1_RiverFisher from './action_cards/hive/season_one/Hive_SeasonCards_2026-07-23_S1_RiverFisher.png';

export const hiveActionS1Images = [
    Hive_SeasonCards_2026_07_23_S1_CaveFisher,
    Hive_SeasonCards_2026_07_23_S1_FarmClearer,
    Hive_SeasonCards_2026_07_23_S1_FarmMiner,
    Hive_SeasonCards_2026_07_23_S1_NoviceFisher,
    Hive_SeasonCards_2026_07_23_S1_NoviceForager,
    Hive_SeasonCards_2026_07_23_S1_NoviceMiner,
    Hive_SeasonCards_2026_07_23_S1_RiverDredger,
    Hive_SeasonCards_2026_07_23_S1_RiverFisher
];

import Cellar_SeasonCards_2026_07_23_S1_CaveFisher from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_CaveFisher.png';
import Cellar_SeasonCards_2026_07_23_S1_FarmClearer from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_FarmClearer.png';
import Cellar_SeasonCards_2026_07_23_S1_FarmMiner from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_FarmMiner.png';
import Cellar_SeasonCards_2026_07_23_S1_NoviceFisher from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_NoviceFisher.png';
import Cellar_SeasonCards_2026_07_23_S1_NoviceForager from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_NoviceForager.png';
import Cellar_SeasonCards_2026_07_23_S1_NoviceMiner from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_NoviceMiner.png';
import Cellar_SeasonCards_2026_07_23_S1_RiverDredger from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_RiverDredger.png';
import Cellar_SeasonCards_2026_07_23_S1_RiverFisher from './action_cards/hive/season_one/Cellar_SeasonCards_2026-07-23_S1_RiverFisher.png';

export const cellarActionS1Images = [
    Cellar_SeasonCards_2026_07_23_S1_CaveFisher,
    Cellar_SeasonCards_2026_07_23_S1_FarmClearer,
    Cellar_SeasonCards_2026_07_23_S1_FarmMiner,
    Cellar_SeasonCards_2026_07_23_S1_NoviceFisher,
    Cellar_SeasonCards_2026_07_23_S1_NoviceForager,
    Cellar_SeasonCards_2026_07_23_S1_NoviceMiner,
    Cellar_SeasonCards_2026_07_23_S1_RiverDredger,
    Cellar_SeasonCards_2026_07_23_S1_RiverFisher
];

import Task_v2_S1_AxeMiner from './action_cards/season_one/advanced/Task_v2_S1_AxeMiner.png';
import Task_v2_S1_EnergyEnthusiast from './action_cards/season_one/advanced/Task_v2_S1_EnergyEnthusiast.png';
import Task_v2_S1_FarmFisher from './action_cards/season_one/advanced/Task_v2_S1_FarmFisher.png';
import Task_v2_S1_Gatherer from './action_cards/season_one/advanced/Task_v2_S1_Gatherer.png';
import Task_v2_S1_Grower from './action_cards/season_one/advanced/Task_v2_S1_Grower.png';
import Task_v2_S1_NatureCollector from './action_cards/season_one/advanced/Task_v2_S1_NatureCollector.png';
import Task_v2_S1_NoviceCollector from './action_cards/season_one/advanced/Task_v2_S1_NoviceCollector.png';
import Task_v2_S1_ShinyCollector from './action_cards/season_one/advanced/Task_v2_S1_ShinyCollector.png';
import Task_v2_S1_SkilledApprentice from './action_cards/season_one/advanced/Task_v2_S1_SkilledApprentice.png';
import Task_v2_S1_SkilledFisher from './action_cards/season_one/advanced/Task_v2_S1_SkilledFisher.png';
import Task_v2_S1_SocialButterfly from './action_cards/season_one/advanced/Task_v2_S1_SocialButterfly.png';
import Task_v2_S1_WoodScrapper from './action_cards/season_one/advanced/Task_v2_S1_WoodScrapper.png';

export const actionS1FlexImages = [
    Task_v2_S1_AxeMiner,
    Task_v2_S1_EnergyEnthusiast,
    Task_v2_S1_FarmFisher,
    Task_v2_S1_Gatherer,
    Task_v2_S1_Grower,
    Task_v2_S1_NatureCollector,
    Task_v2_S1_NoviceCollector,
    Task_v2_S1_ShinyCollector,
    Task_v2_S1_SkilledApprentice,
    Task_v2_S1_SkilledFisher,
    Task_v2_S1_SocialButterfly,
    Task_v2_S1_WoodScrapper
];

import Task_v2_S2_AmateurFarmer from './action_cards/season_two/base/Task_v2_S2_AmateurFarmer.png';
import Task_v2_S2_CovernGrower from './action_cards/season_two/base/Task_v2_S2_CovernGrower.png';
import Task_v2_S2_Excavator from './action_cards/season_two/base/Task_v2_S2_Excavator.png';
import Task_v2_S2_ExpertFisher from './action_cards/season_two/base/Task_v2_S2_ExpertFisher.png';
import Task_v2_S2_FarmForester from './action_cards/season_two/base/Task_v2_S2_FarmForester.png';
import Task_v2_S2_LumberjackFisher from './action_cards/season_two/base/Task_v2_S2_LumberjackFisher.png';
import Task_v2_S2_SecretMineFisher from './action_cards/season_two/base/Task_v2_S2_SecretMineFisher.png';
import Task_v2_S2_WoodsClearer from './action_cards/season_two/base/Task_v2_S2_WoodsClearer.png';

export const actionS2BaseImages = [
    Task_v2_S2_AmateurFarmer,
    Task_v2_S2_CovernGrower,
    Task_v2_S2_Excavator,
    Task_v2_S2_ExpertFisher,
    Task_v2_S2_FarmForester,
    Task_v2_S2_LumberjackFisher,
    Task_v2_S2_SecretMineFisher,
    Task_v2_S2_WoodsClearer
];

import Hive_SeasonCards_2026_07_23_S2_AmateurFarmer from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_AmateurFarmer.png';
import Hive_SeasonCards_2026_07_23_S2_CovernGrower from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_CovernGrower.png';
import Hive_SeasonCards_2026_07_23_S2_Excavator from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_Excavator.png';
import Hive_SeasonCards_2026_07_23_S2_ExpertFisher from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_ExpertFisher.png';
import Hive_SeasonCards_2026_07_23_S2_FarmForester from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_FarmForester.png';
import Hive_SeasonCards_2026_07_23_S2_LumberjackFisher from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_LumberjackFisher.png';
import Hive_SeasonCards_2026_07_23_S2_SecretMineFisher from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_SecretMineFisher.png';
import Hive_SeasonCards_2026_07_23_S2_WoodsClearer from './action_cards/hive/season_two/Hive_SeasonCards_2026-07-23_S2_WoodsClearer.png';

export const hiveActionS2Images = [
    Hive_SeasonCards_2026_07_23_S2_AmateurFarmer,
    Hive_SeasonCards_2026_07_23_S2_CovernGrower,
    Hive_SeasonCards_2026_07_23_S2_Excavator,
    Hive_SeasonCards_2026_07_23_S2_ExpertFisher,
    Hive_SeasonCards_2026_07_23_S2_FarmForester,
    Hive_SeasonCards_2026_07_23_S2_LumberjackFisher,
    Hive_SeasonCards_2026_07_23_S2_SecretMineFisher,
    Hive_SeasonCards_2026_07_23_S2_WoodsClearer
];

import Cellar_SeasonCards_2026_07_23_S2_AmateurFarmer from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_AmateurFarmer.png';
import Cellar_SeasonCards_2026_07_23_S2_CovernGrower from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_CovernGrower.png';
import Cellar_SeasonCards_2026_07_23_S2_Excavator from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_Excavator.png';
import Cellar_SeasonCards_2026_07_23_S2_ExpertFisher from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_ExpertFisher.png';
import Cellar_SeasonCards_2026_07_23_S2_FarmForester from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_FarmForester.png';
import Cellar_SeasonCards_2026_07_23_S2_LumberjackFisher from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_LumberjackFisher.png';
import Cellar_SeasonCards_2026_07_23_S2_SecretMineFisher from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_SecretMineFisher.png';
import Cellar_SeasonCards_2026_07_23_S2_WoodsClearer from './action_cards/hive/season_two/Cellar_SeasonCards_2026-07-23_S2_WoodsClearer.png';

export const cellarActionS2Images = [
    Cellar_SeasonCards_2026_07_23_S2_AmateurFarmer,
    Cellar_SeasonCards_2026_07_23_S2_CovernGrower,
    Cellar_SeasonCards_2026_07_23_S2_Excavator,
    Cellar_SeasonCards_2026_07_23_S2_ExpertFisher,
    Cellar_SeasonCards_2026_07_23_S2_FarmForester,
    Cellar_SeasonCards_2026_07_23_S2_LumberjackFisher,
    Cellar_SeasonCards_2026_07_23_S2_SecretMineFisher,
    Cellar_SeasonCards_2026_07_23_S2_WoodsClearer
];

import Task_v2_S2_Collector from './action_cards/season_two/advanced/Task_v2_S2_Collector.png';
import Task_v2_S2_Evergizer from './action_cards/season_two/advanced/Task_v2_S2_Evergizer.png';
import Task_v2_S2_Extrovert from './action_cards/season_two/advanced/Task_v2_S2_Extrovert.png';
import Task_v2_S2_FarmExcavator from './action_cards/season_two/advanced/Task_v2_S2_FarmExcavator.png';
import Task_v2_S2_Furnisher from './action_cards/season_two/advanced/Task_v2_S2_Furnisher.png';
import Task_v2_S2_GeneralistMedalEarner from './action_cards/season_two/advanced/Task_v2_S2_GeneralistMedalEarner.png';
import Task_v2_S2_JackOfAllTrades from './action_cards/season_two/advanced/Task_v2_S2_JackOfAllTrades.png';
import Task_v2_S2_LureMaster from './action_cards/season_two/advanced/Task_v2_S2_LureMaster.png';
import Task_v2_S2_MedalEarner from './action_cards/season_two/advanced/Task_v2_S2_MedalEarner.png';
import Task_v2_S2_Pragmatist from './action_cards/season_two/advanced/Task_v2_S2_Pragmatist.png';
import Task_v2_S2_ProjectDabbler from './action_cards/season_two/advanced/Task_v2_S2_ProjectDabbler.png';
import Task_v2_S2_Retooler from './action_cards/season_two/advanced/Task_v2_S2_Retooler.png';

export const actionS2FlexImages = [
    Task_v2_S2_Collector,
    Task_v2_S2_Evergizer,
    Task_v2_S2_Extrovert,
    Task_v2_S2_FarmExcavator,
    Task_v2_S2_Furnisher,
    Task_v2_S2_GeneralistMedalEarner,
    Task_v2_S2_JackOfAllTrades,
    Task_v2_S2_LureMaster,
    Task_v2_S2_MedalEarner,
    Task_v2_S2_Pragmatist,
    Task_v2_S2_ProjectDabbler,
    Task_v2_S2_Retooler
];

import Task_v2_S3_Delver from './action_cards/season_three/base/Task_v2_S3_Delver.png';
import Task_v2_S3_FreshFarmer from './action_cards/season_three/base/Task_v2_S3_FreshFarmer.png';
import Task_v2_S3_Geologist from './action_cards/season_three/base/Task_v2_S3_Geologist.png';
import Task_v2_S3_GrottoFisher from './action_cards/season_three/base/Task_v2_S3_GrottoFisher.png';
import Task_v2_S3_Kingfisher from './action_cards/season_three/base/Task_v2_S3_Kingfisher.png';
import Task_v2_S3_LakeFisher from './action_cards/season_three/base/Task_v2_S3_LakeFisher.png';
import Task_v2_S3_MasterFarmer from './action_cards/season_three/base/Task_v2_S3_MasterFarmer.png';
import Task_v2_S3_Woodsman from './action_cards/season_three/base/Task_v2_S3_Woodsman.png';

export const actionS3BaseImages = [
    Task_v2_S3_Delver,
    Task_v2_S3_FreshFarmer,
    Task_v2_S3_Geologist,
    Task_v2_S3_GrottoFisher,
    Task_v2_S3_Kingfisher,
    Task_v2_S3_LakeFisher,
    Task_v2_S3_MasterFarmer,
    Task_v2_S3_Woodsman
];

import Hive_SeasonCards_2026_07_23_S3_Delver from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_Delver.png';
import Hive_SeasonCards_2026_07_23_S3_FreshFarmer from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_FreshFarmer.png';
import Hive_SeasonCards_2026_07_23_S3_Geologist from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_Geologist.png';
import Hive_SeasonCards_2026_07_23_S3_GrottoFisher from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_GrottoFisher.png';
import Hive_SeasonCards_2026_07_23_S3_Kingfisher from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_Kingfisher.png';
import Hive_SeasonCards_2026_07_23_S3_LakeFisher from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_LakeFisher.png';
import Hive_SeasonCards_2026_07_23_S3_MasterFarmer from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_MasterFarmer.png';
import Hive_SeasonCards_2026_07_23_S3_Woodsman from './action_cards/hive/season_three/Hive_SeasonCards_2026-07-23_S3_Woodsman.png';

export const hiveActionS3Images = [
    Hive_SeasonCards_2026_07_23_S3_Delver,
    Hive_SeasonCards_2026_07_23_S3_FreshFarmer,
    Hive_SeasonCards_2026_07_23_S3_Geologist,
    Hive_SeasonCards_2026_07_23_S3_GrottoFisher,
    Hive_SeasonCards_2026_07_23_S3_Kingfisher,
    Hive_SeasonCards_2026_07_23_S3_LakeFisher,
    Hive_SeasonCards_2026_07_23_S3_MasterFarmer,
    Hive_SeasonCards_2026_07_23_S3_Woodsman
];

import Cellar_SeasonCards_2026_07_23_S3_Delver from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_Delver.png';
import Cellar_SeasonCards_2026_07_23_S3_FreshFarmer from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_FreshFarmer.png';
import Cellar_SeasonCards_2026_07_23_S3_Geologist from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_Geologist.png';
import Cellar_SeasonCards_2026_07_23_S3_GrottoFisher from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_GrottoFisher.png';
import Cellar_SeasonCards_2026_07_23_S3_Kingfisher from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_Kingfisher.png';
import Cellar_SeasonCards_2026_07_23_S3_LakeFisher from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_LakeFisher.png';
import Cellar_SeasonCards_2026_07_23_S3_MasterFarmer from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_MasterFarmer.png';
import Cellar_SeasonCards_2026_07_23_S3_Woodsman from './action_cards/hive/season_three/Cellar_SeasonCards_2026-07-23_S3_Woodsman.png';

export const cellarActionS3Images = [
    Cellar_SeasonCards_2026_07_23_S3_Delver,
    Cellar_SeasonCards_2026_07_23_S3_FreshFarmer,
    Cellar_SeasonCards_2026_07_23_S3_Geologist,
    Cellar_SeasonCards_2026_07_23_S3_GrottoFisher,
    Cellar_SeasonCards_2026_07_23_S3_Kingfisher,
    Cellar_SeasonCards_2026_07_23_S3_LakeFisher,
    Cellar_SeasonCards_2026_07_23_S3_MasterFarmer,
    Cellar_SeasonCards_2026_07_23_S3_Woodsman
];

import Task_v2_S3_AntiAntiSocial from './action_cards/season_three/advanced/Task_v2_S3_AntiAntiSocial.png';
import Task_v2_S3_CompleteBuilder from './action_cards/season_three/advanced/Task_v2_S3_CompleteBuilder.png';
import Task_v2_S3_Completist from './action_cards/season_three/advanced/Task_v2_S3_Completist.png';
import Task_v2_S3_EnergyMonster from './action_cards/season_three/advanced/Task_v2_S3_EnergyMonster.png';
import Task_v2_S3_FishHunter from './action_cards/season_three/advanced/Task_v2_S3_FishHunter.png';
import Task_v2_S3_MarketCultivator from './action_cards/season_three/advanced/Task_v2_S3_MarketCultivator.png';
import Task_v2_S3_MarketDelver from './action_cards/season_three/advanced/Task_v2_S3_MarketDelver.png';
import Task_v2_S3_MarketMaster from './action_cards/season_three/advanced/Task_v2_S3_MarketMaster.png';
import Task_v2_S3_MarketWizard from './action_cards/season_three/advanced/Task_v2_S3_MarketWizard.png';
import Task_v2_S3_MasterBuilder from './action_cards/season_three/advanced/Task_v2_S3_MasterBuilder.png';
import Task_v2_S3_ResearchBadgeMaster from './action_cards/season_three/advanced/Task_v2_S3_ResearchBadgeMaster.png';
import Task_v2_S3_WoodsExplorer from './action_cards/season_three/advanced/Task_v2_S3_WoodsExplorer.png';

export const actionS3FlexImages = [
    Task_v2_S3_AntiAntiSocial,
    Task_v2_S3_CompleteBuilder,
    Task_v2_S3_Completist,
    Task_v2_S3_EnergyMonster,
    Task_v2_S3_FishHunter,
    Task_v2_S3_MarketCultivator,
    Task_v2_S3_MarketDelver,
    Task_v2_S3_MarketMaster,
    Task_v2_S3_MarketWizard,
    Task_v2_S3_MasterBuilder,
    Task_v2_S3_ResearchBadgeMaster,
    Task_v2_S3_WoodsExplorer
];

import NewModulesIncoming_S1_NewEquipment from './action_cards/seed_events/newmodulesincoming/NewModulesIncoming_S1_NewEquipment.png';
import NewModulesIncoming_S2_Adaptation from './action_cards/seed_events/newmodulesincoming/NewModulesIncoming_S2_Adaptation.png';
import NewModulesIncoming_S3_Investments from './action_cards/seed_events/newmodulesincoming/NewModulesIncoming_S3_Investments.png';

export const seedEventActionImages = [
    NewModulesIncoming_S1_NewEquipment,
    NewModulesIncoming_S2_Adaptation,
    NewModulesIncoming_S3_Investments
];

import Objective_S1_BadgeBonus from './old_cards/Objective_S1_BadgeBonus.png';
import Objective_S1_BigGuy from './old_cards/Objective_S1_BigGuy.png';
import Objective_S1_CentralSampler from './old_cards/Objective_S1_CentralSampler.png';
import Objective_S1_Clearer from './old_cards/Objective_S1_Clearer.png';
import Objective_S1_Edges from './old_cards/Objective_S1_Edges.png';
import Objective_S1_LeftSampler from './old_cards/Objective_S1_LeftSampler.png';
import Objective_S1_Loner from './old_cards/Objective_S1_Loner.png';
import Objective_S1_Muncher from './old_cards/Objective_S1_Muncher.png';
import Objective_S1_ProjectBonus from './old_cards/Objective_S1_ProjectBonus.png';
import Objective_S1_RightSampler from './old_cards/Objective_S1_RightSampler.png';
import Objective_S1_Shrimp from './old_cards/Objective_S1_Shrimp.png';
import Objective_S1_Socialite from './old_cards/Objective_S1_Socialite.png';
import Objective_S2_AnimalHandler from './old_cards/Objective_S2_AnimalHandler.png';
import Objective_S2_Biggen from './old_cards/Objective_S2_Biggen.png';
import Objective_S2_Borders from './old_cards/Objective_S2_Borders.png';
import Objective_S2_CenterSampler from './old_cards/Objective_S2_CenterSampler.png';
import Objective_S2_Cruncher from './old_cards/Objective_S2_Cruncher.png';
import Objective_S2_EastSampler from './old_cards/Objective_S2_EastSampler.png';
import Objective_S2_Explorer from './old_cards/Objective_S2_Explorer.png';
import Objective_S2_MeritEarner from './old_cards/Objective_S2_MeritEarner.png';
import Objective_S2_Moderate from './old_cards/Objective_S2_Moderate.png';
import Objective_S2_Organizer from './old_cards/Objective_S2_Organizer.png';
import Objective_S2_Shrimp from './old_cards/Objective_S2_Shrimp.png';
import Objective_S2_Spacer from './old_cards/Objective_S2_Spacer.png';
import Objective_S2_Upgrader from './old_cards/Objective_S2_Upgrader.png';
import Objective_S2_WestSampler from './old_cards/Objective_S2_WestSampler.png';
import Objective_S3_Assembler from './old_cards/Objective_S3_Assembler.png';
import Objective_S3_CargoMaster from './old_cards/Objective_S3_CargoMaster.png';
import Objective_S3_Centrist from './old_cards/Objective_S3_Centrist.png';
import Objective_S3_Lefty from './old_cards/Objective_S3_Lefty.png';
import Objective_S3_Minimalist from './old_cards/Objective_S3_Minimalist.png';
import Objective_S3_Righty from './old_cards/Objective_S3_Righty.png';
import Objective_S3_TrueFriend from './old_cards/Objective_S3_TrueFriend.png';
import Objective_S3_WideSpacer from './old_cards/Objective_S3_WideSpacer.png';
import Season1Action_AxeMiner from './old_cards/Season1Action_AxeMiner.png';
import Season1Action_CaveFisher from './old_cards/Season1Action_CaveFisher.png';
import Season1Action_EnergyEnthusiast from './old_cards/Season1Action_EnergyEnthusiast.png';
import Season1Action_FarmClearer from './old_cards/Season1Action_FarmClearer.png';
import Season1Action_FarmFisher from './old_cards/Season1Action_FarmFisher.png';
import Season1Action_FarmMiner from './old_cards/Season1Action_FarmMiner.png';
import Season1Action_Gatherer from './old_cards/Season1Action_Gatherer.png';
import Season1Action_Grower from './old_cards/Season1Action_Grower.png';
import Season1Action_NatureCollector from './old_cards/Season1Action_NatureCollector.png';
import Season1Action_NoviceCollector from './old_cards/Season1Action_NoviceCollector.png';
import Season1Action_NoviceFisher from './old_cards/Season1Action_NoviceFisher.png';
import Season1Action_NoviceForager from './old_cards/Season1Action_NoviceForager.png';
import Season1Action_NoviceMiner from './old_cards/Season1Action_NoviceMiner.png';
import Season1Action_RiverDredger from './old_cards/Season1Action_RiverDredger.png';
import Season1Action_RiverFisher from './old_cards/Season1Action_RiverFisher.png';
import Season1Action_ShinyCollector from './old_cards/Season1Action_ShinyCollector.png';
import Season1Action_SkilledApprentice from './old_cards/Season1Action_SkilledApprentice.png';
import Season1Action_SkilledFisher from './old_cards/Season1Action_SkilledFisher.png';
import Season1Action_SocialButterfly from './old_cards/Season1Action_SocialButterfly.png';
import Season1Action_WoodScrapper from './old_cards/Season1Action_WoodScrapper.png';
import Season2Action_AmateurFarmer from './old_cards/Season2Action_AmateurFarmer.png';
import Season2Action_Collector from './old_cards/Season2Action_Collector.png';
import Season2Action_CovernGrower from './old_cards/Season2Action_CovernGrower.png';
import Season2Action_Evergizer from './old_cards/Season2Action_Evergizer.png';
import Season2Action_Excavator from './old_cards/Season2Action_Excavator.png';
import Season2Action_ExpertFisher from './old_cards/Season2Action_ExpertFisher.png';
import Season2Action_Extrovert from './old_cards/Season2Action_Extrovert.png';
import Season2Action_FarmExcavator from './old_cards/Season2Action_FarmExcavator.png';
import Season2Action_FarmForester from './old_cards/Season2Action_FarmForester.png';
import Season2Action_Furnisher from './old_cards/Season2Action_Furnisher.png';
import Season2Action_GeneralistMedalEarner from './old_cards/Season2Action_GeneralistMedalEarner.png';
import Season2Action_JackOfAllTrades from './old_cards/Season2Action_JackOfAllTrades.png';
import Season2Action_LumberjackFisher from './old_cards/Season2Action_LumberjackFisher.png';
import Season2Action_LureMaster from './old_cards/Season2Action_LureMaster.png';
import Season2Action_MedalEarner from './old_cards/Season2Action_MedalEarner.png';
import Season2Action_Pragmatist from './old_cards/Season2Action_Pragmatist.png';
import Season2Action_ProjectDabbler from './old_cards/Season2Action_ProjectDabbler.png';
import Season2Action_Retooler from './old_cards/Season2Action_Retooler.png';
import Season2Action_SecretMineFisher from './old_cards/Season2Action_SecretMineFisher.png';
import Season2Action_WoodCleaner from './old_cards/Season2Action_WoodCleaner.png';
import Season3Action_AntiAntiSocial from './old_cards/Season3Action_AntiAntiSocial.png';
import Season3Action_CompleteBuilder from './old_cards/Season3Action_CompleteBuilder.png';
import Season3Action_Completist from './old_cards/Season3Action_Completist.png';
import Season3Action_Delver from './old_cards/Season3Action_Delver.png';
import Season3Action_EnergyMonster from './old_cards/Season3Action_EnergyMonster.png';
import Season3Action_FishHunter from './old_cards/Season3Action_FishHunter.png';
import Season3Action_FreshFarmer from './old_cards/Season3Action_FreshFarmer.png';
import Season3Action_Geologist from './old_cards/Season3Action_Geologist.png';
import Season3Action_GrottoFisher from './old_cards/Season3Action_GrottoFisher.png';
import Season3Action_Kingfisher from './old_cards/Season3Action_Kingfisher.png';
import Season3Action_LakeFisher from './old_cards/Season3Action_LakeFisher.png';
import Season3Action_MarketCultivator from './old_cards/Season3Action_MarketCultivator.png';
import Season3Action_MarketDelver from './old_cards/Season3Action_MarketDelver.png';
import Season3Action_MarketMaster from './old_cards/Season3Action_MarketMaster.png';
import Season3Action_MarketWizard from './old_cards/Season3Action_MarketWizard.png';
import Season3Action_MasterBuilder from './old_cards/Season3Action_MasterBuilder.png';
import Season3Action_MasterFarmer from './old_cards/Season3Action_MasterFarmer.png';
import Season3Action_ResearchBadgeMaster from './old_cards/Season3Action_ResearchBadgeMaster.png';
import Season3Action_WoodsExplorer from './old_cards/Season3Action_WoodsExplorer.png';
import Season3Action_Woodsman from './old_cards/Season3Action_Woodsman.png';

export const oldCardImages = [
    Objective_S1_BadgeBonus,
    Objective_S1_BigGuy,
    Objective_S1_CentralSampler,
    Objective_S1_Clearer,
    Objective_S1_Edges,
    Objective_S1_LeftSampler,
    Objective_S1_Loner,
    Objective_S1_Muncher,
    Objective_S1_ProjectBonus,
    Objective_S1_RightSampler,
    Objective_S1_Shrimp,
    Objective_S1_Socialite,
    Objective_S2_AnimalHandler,
    Objective_S2_Biggen,
    Objective_S2_Borders,
    Objective_S2_CenterSampler,
    Objective_S2_Cruncher,
    Objective_S2_EastSampler,
    Objective_S2_Explorer,
    Objective_S2_MeritEarner,
    Objective_S2_Moderate,
    Objective_S2_Organizer,
    Objective_S2_Shrimp,
    Objective_S2_Spacer,
    Objective_S2_Upgrader,
    Objective_S2_WestSampler,
    Objective_S3_Assembler,
    Objective_S3_CargoMaster,
    Objective_S3_Centrist,
    Objective_S3_Lefty,
    Objective_S3_Minimalist,
    Objective_S3_Righty,
    Objective_S3_TrueFriend,
    Objective_S3_WideSpacer,
    Season1Action_AxeMiner,
    Season1Action_CaveFisher,
    Season1Action_EnergyEnthusiast,
    Season1Action_FarmClearer,
    Season1Action_FarmFisher,
    Season1Action_FarmMiner,
    Season1Action_Gatherer,
    Season1Action_Grower,
    Season1Action_NatureCollector,
    Season1Action_NoviceCollector,
    Season1Action_NoviceFisher,
    Season1Action_NoviceForager,
    Season1Action_NoviceMiner,
    Season1Action_RiverDredger,
    Season1Action_RiverFisher,
    Season1Action_ShinyCollector,
    Season1Action_SkilledApprentice,
    Season1Action_SkilledFisher,
    Season1Action_SocialButterfly,
    Season1Action_WoodScrapper,
    Season2Action_AmateurFarmer,
    Season2Action_Collector,
    Season2Action_CovernGrower,
    Season2Action_Evergizer,
    Season2Action_Excavator,
    Season2Action_ExpertFisher,
    Season2Action_Extrovert,
    Season2Action_FarmExcavator,
    Season2Action_FarmForester,
    Season2Action_Furnisher,
    Season2Action_GeneralistMedalEarner,
    Season2Action_JackOfAllTrades,
    Season2Action_LumberjackFisher,
    Season2Action_LureMaster,
    Season2Action_MedalEarner,
    Season2Action_Pragmatist,
    Season2Action_ProjectDabbler,
    Season2Action_Retooler,
    Season2Action_SecretMineFisher,
    Season2Action_WoodCleaner,
    Season3Action_AntiAntiSocial,
    Season3Action_CompleteBuilder,
    Season3Action_Completist,
    Season3Action_Delver,
    Season3Action_EnergyMonster,
    Season3Action_FishHunter,
    Season3Action_FreshFarmer,
    Season3Action_Geologist,
    Season3Action_GrottoFisher,
    Season3Action_Kingfisher,
    Season3Action_LakeFisher,
    Season3Action_MarketCultivator,
    Season3Action_MarketDelver,
    Season3Action_MarketMaster,
    Season3Action_MarketWizard,
    Season3Action_MasterBuilder,
    Season3Action_MasterFarmer,
    Season3Action_ResearchBadgeMaster,
    Season3Action_WoodsExplorer,
    Season3Action_Woodsman
];
